var map = {
	"./BundleIcon.js": 271,
	"./ConsumptionIcon.js": 345,
	"./CreateFreezeIcon.js": 916,
	"./DataIcon.js": 917,
	"./InternetIcon.js": 269,
	"./InvoicesIcon.js": 263,
	"./LandLineIcon.js": 268,
	"./MispariIcon.js": 344,
	"./MobileIcon.js": 267,
	"./MyServicesIcon.js": 264,
	"./ParametersIcon.js": 918,
	"./ProfileIcon.js": 265,
	"./RoamingIcon.js": 919,
	"./SignOutIcon.js": 266,
	"./TvIcon.js": 270,
	"./UnFreezeIcon.js": 920,
	"./VoiceMailIcon.js": 921
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 915;


//////////////////
// WEBPACK FOOTER
// ./src/components/Icons ^\.\/.*Icon\.js$
// module id = 915
// module chunks = 0